import React from "react";
import { IconArrowRight } from "@synthesis/shared-icons";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/Breadcrumbs/index.tsx
const handleKeyPress = (event, refs, breadcrumb, length) => {
	if (event.code === "ArrowRight" && breadcrumb.id < length) {
		refs[breadcrumb.id + 1]?.focus();
		return;
	}
	if (event.code === "ArrowLeft" && breadcrumb.id > 1) {
		refs[breadcrumb.id - 1]?.focus();
		return;
	}
	if (event.code === "Space" || event.code === "Enter") {
		event.preventDefault();
		window.location.assign(breadcrumb.path);
	}
};
/**
* Breadcrumbs из нового UI Kit'a.
* Дизайн: - https://www.figma.com/file/uRPlsieHFpRpRsYDX2KV1Q/%D0%90%D1%81%D1%83%D0%B1%D0%B8%D0%BC.-%D0%A0%D0%96%D0%94-UI-Kit?node-id=468%3A7976
* @param items [{id, title, path, leftIcon, rightIcon}]
* @param id Уникальный идентификатор
* @param title Наименование
* @param path Ссылка
* @param leftIcon Левая картинка
* @param rightIcon Правая картинка
*/
const Breadcrumbs = React.memo(({ items }) => {
	const itemsRefs = React.useRef({});
	const lastItem = items.at(-1) ?? null;
	const setItemRef = (id) => (element) => {
		if (element) {
			itemsRefs.current[id] = element;
			return;
		}
		delete itemsRefs.current[id];
	};
	const renderListElements = items.map((breadcrumb, index) => {
		if (index === items.length - 1) return null;
		return /* @__PURE__ */ jsxs("li", {
			className: cn("text-type-light flex min-w-12 items-center gap-2", breadcrumb.isProject && "overflow-hidden"),
			children: [/* @__PURE__ */ jsx("div", {
				"data-cy": "breadcrumbs-div",
				className: "overflow-hidden",
				children: /* @__PURE__ */ jsx(BreadcrumbItem, {
					items,
					breadcrumb,
					itemRefs: itemsRefs,
					setItemRef
				})
			}), /* @__PURE__ */ jsx(IconArrowRight, { className: "text-neutrals-60 size-4" })]
		}, breadcrumb.id);
	});
	return /* @__PURE__ */ jsx("nav", {
		"data-cy": "breadcrumbs-nav",
		className: "w-[calc(90%-86px)]",
		"aria-label": "breadcrumbs",
		children: /* @__PURE__ */ jsxs("ol", {
			className: "flex gap-2",
			children: [renderListElements, lastItem && /* @__PURE__ */ jsx("li", {
				"data-cy": "breadcrumbs-liLastItem",
				"aria-current": "page",
				className: cn("text-labels-secondary min-w-10 max-w-full overflow-hidden", lastItem.isProject && "min-w-32"),
				children: /* @__PURE__ */ jsx(BreadcrumbItem, {
					items,
					breadcrumb: lastItem,
					itemRefs: itemsRefs,
					setItemRef
				})
			}, lastItem.id)]
		})
	});
});
Breadcrumbs.displayName = "Breadcrumbs";
const BreadcrumbItem = ({ breadcrumb, items, itemRefs, setItemRef }) => {
	return /* @__PURE__ */ jsxs("a", {
		href: breadcrumb.path,
		title: breadcrumb.title,
		ref: setItemRef(breadcrumb.id),
		"data-cy": "breadcrumbs-navLink",
		onKeyDown: (event) => handleKeyPress(event, itemRefs.current, breadcrumb, items.length),
		className: cn("flex items-center gap-2 px-2 py-0.5 transition-all", "hover:text-labels-secondary active:text-labels-secondary text-sm font-medium", "hover:bg-neutrals-90 rounded focus:outline active:bg-transparent active:outline-none", "outline-system-info-70 focus:outline-system-info-70 outline-2 -outline-offset-2"),
		children: [
			breadcrumb.leftIcon && /* @__PURE__ */ jsx("i", {
				"data-cy": "breadcrumbs-i",
				className: "size-4",
				children: breadcrumb.leftIcon
			}),
			/* @__PURE__ */ jsx("span", {
				"data-cy": "breadcrumbs-span",
				className: "truncate",
				children: breadcrumb.title
			}),
			breadcrumb.rightIcon && /* @__PURE__ */ jsx("i", {
				className: "size-4",
				children: breadcrumb.rightIcon
			})
		]
	});
};
//#endregion
export { Breadcrumbs };

//# sourceMappingURL=index.js.map